module.exports = __webpack_public_path__ + "public/files/img/9-small.30df7a62.png";